function getClientEnvironment() {
  if (typeof window !== 'undefined') {
    const hostname = window.location?.hostname ?? ''
    if (hostname.includes('dev') || hostname.includes('staging')) {
      return 'Staging'
    }
    if (hostname === 'localhost') {
      return 'Local'
    }
  }
  return 'Prod'
}

export class NRLogger {
  static info(pageAction, data) {
    this.log('info', pageAction, data)
  }

  static error(pageAction, data) {
    this.log('error', pageAction, data)
  }

  static log(logLevel, pageAction, data) {
    if (window && window.newrelic) {
      window.newrelic.addPageAction(pageAction, {
        ...data,
        environment: getClientEnvironment(),
        logLevel,
      })
    }
  }
}
